import React, { Component } from 'react';

import ShippingLabel from './ShippingLabel';

const renderShippingLabels = labels => (
  labels.map((label, index) => (
    <ShippingLabel label={label} index={index} key={label.trackingID} total={labels.length} />
  ))
);

class ShippingLabels extends Component {
  constructor(props) {
    super(props);
    this.handleAddNewLabelClick = this.handleAddNewLabelClick.bind(this);
  }

  handleAddNewLabelClick(e) {
    const { handleFetchNewLabel, returnOrderId } = this.props;
    e.preventDefault();
    handleFetchNewLabel(returnOrderId);
  }

  render() {
    const { labels, showGenerateLabel, loading } = this.props;

    return (
      <>
        {renderShippingLabels(labels)}
        {showGenerateLabel && (
        <div className="card-group__item">
          <div className="card card--secondary">
            <div className="card__content">
              <p className="body3">
                {'Can\'t fit everything in one box? '}
                <button
                  type="button"
                  className={`button button--text ${(loading) ? 'is-loading' : ''}`}
                  onClick={this.handleAddNewLabelClick}
                >
                  Create Another Label
                </button>
              </p>
            </div>
          </div>
        </div>
        )}
      </>
    );
  }
}

export default ShippingLabels;
